<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('amount')">
          <el-input
            v-model="queryForm.amount"
            size="small"
            maxlength="11"
            @input="
              queryForm.amount = queryForm.amount
                .replace(/[^0-9]/g, '')
                .formatMoney(0, ' ')
            "
          />
        </el-form-item>
        <el-form-item :label="$t('creationTime')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="btnStatus.isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row
        class="table-btns"
        v-if="loginInfo.orgType == 3 && loginInfo.job == 'DISTRIBUTEUR'"
      >
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="addRecordVisible()"
          >{{ $t("add remunerationToCash") }}</el-button
        >

        <span style="font-size: 13px; color: #606266; margin-left: 40px">
          {{ $t("totalCommissionAmount") }} :
          <strong style="color: #1164c4; font-size: 14px">
            FCFA {{ globalTotalAmount }}
          </strong>
        </span>
      </el-row>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="btnStatus.isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="60"
        ></el-table-column>
        <el-table-column prop="createName" :label="$t('org')" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.createName }} {{ scope.row.createSurname }} ({{
              scope.row.createLoginName
            }})
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('remunerationToCashAmount')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('date remuneration To Cash')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createTime).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('remunerationType')" min-width="130">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              v-if="scope.row.remunerationType == 0"
              type="info"
            >
              {{ $t("myself") }}
            </el-tag>
            <el-tag
              size="mini"
              v-else-if="scope.row.remunerationType == 1"
              type="success"
            >
              {{ $t("agent") }}
            </el-tag>
            <el-tag
              size="mini"
              v-else-if="scope.row.remunerationType == 2"
              type="warning"
            >
              {{ $t("all") }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('remuneration')" min-width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.agentName">
              {{ scope.row.agentName }} {{ scope.row.agentSurname }} ({{
                scope.row.agentLoginName
              }})
            </span>
            <span v-else class="text-muted">{{ $t("myself") }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="remark"
          :label="$t('remark')"
          min-width="180"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t('remunerationToCash')"
      :visible.sync="isVisible"
      :size="420"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
    >
      <div
        style="padding: 0 20px 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 8px"
      >
        <span style="font-size: 13px; color: #606266">
          {{ $t("totalCommissionAmount") }} :
          <strong style="color: #1164c4; font-size: 14px">
            FCFA {{ globalTotalAmount }}
          </strong>
        </span>
      </div>
      <el-form
        :model="addForm"
        :rules="rules"
        ref="addForm"
        style="padding: 0 20px"
      >
        <el-form-item :label="$t('agent')">
          <el-select
            v-model="addForm.agentId"
            :placeholder="$t('selectAgent')"
            size="medium"
            clearable
            style="width: 100%"
            @change="onAgentChange"
          >
            <el-option :label="$t('myself')" :value="null" />
            <el-option :label="$t('all')" :value="'all'" />
            <el-option
              v-for="a in agentList"
              :key="a.id"
              :label="a.name + ' ' + a.surname + ' (' + a.loginName + ')'"
              :value="a.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('commissionAmount')">
          <el-input size="medium" :value="selectedAccountAmount" disabled>
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <el-form-item
          :label="$t('amount')"
          prop="amount"
          v-if="addForm.agentId !== 'all'"
        >
          <el-input
            size="medium"
            v-model="addForm.amount"
            maxlength="10"
            @input="onAmountInput"
          >
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <!-- Remarque -->
        <el-form-item :label="$t('remark')">
          <el-input type="textarea" size="medium" v-model="addForm.remark" />
        </el-form-item>

        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="btnStatus.isLoading"
            @click="onSubmit('addForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import card from "@/api/card";
import org from "@/api/org";

export default {
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: { type: 3 },
      selectedAgentCard: null,
      checkDrawer: false,
      agentList: [],
      btnStatus: { isLoading: false },
      table: {
        records: [
          {
            createOrg: "长虹（100000）",
            createMember: "张三(1000)",
            receiveOrg: "海尔（200000）",
            receiveMember: "",
            amount: "600000",
            status: 1,
            createTime: "2021-07-11 12:21:18",
            statusTime: undefined,
          },
          {
            createOrg: "海尔（200000）",
            createMember: "李四(2000)",
            receiveOrg: "长虹（100000）",
            receiveMember: "",
            amount: "150000",
            status: 1,
            createTime: "2021-07-01 15:21:18",
            statusTime: undefined,
          },
          {
            createOrg: "长虹（100000）",
            createMember: "张三(1000)",
            receiveOrg: "海尔（200000）",
            receiveMember: "李四(2000)",
            amount: "50000",
            status: 2,
            createTime: "2021-06-21 07:21:18",
            statusTime: "2021-07-11 07:40:28",
          },
        ],
      },
      pageSize: 20,
      currentPage: 1,

      isVisible: false,

      addForm: {},

      //禁用今天之后的日期选项
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //选当前时间之前的时间
        },
      },
      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cardInfo() {
      return this.$store.state.globalParameter.cardInfo;
    },
    rules() {
      return {
        amount: [
          {
            required: this.addForm.agentId !== "all", //
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },

    selectedAccountAmount() {
      if (!this.addForm.agentId) {
        return this.cardInfo.accountAmount != null
          ? String(this.cardInfo.accountAmount).replace(
              /\B(?=(\d{3})+(?!\d))/g,
              " ",
            )
          : "";
      }

      if (this.addForm.agentId === "all") {
        return String(this.selectedAccountAmountRaw).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          " ",
        );
      }

      return this.selectedAgentCard?.accountAmount != null
        ? String(this.selectedAgentCard.accountAmount).replace(
            /\B(?=(\d{3})+(?!\d))/g,
            " ",
          )
        : "";
    },
    selectedAccountAmountRaw() {
      if (!this.addForm.agentId) return this.cardInfo.accountAmount || 0;

      if (this.addForm.agentId === "all") {
        const agentsTotal = this.agentList.reduce((acc, a) => {
          return acc + parseFloat(a.accountAmount || 0);
        }, 0);
        return agentsTotal + parseFloat(this.cardInfo.accountAmount || 0);
      }

      return this.selectedAgentCard?.accountAmount || 0;
    },

    globalTotalAmount() {
      const distrib = parseFloat(this.cardInfo?.accountAmount || 0);
      const agents = this.agentList.reduce((acc, a) => {
        return acc + parseFloat(a.accountAmount || 0);
      }, 0);
      return String(distrib + agents).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },

    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));

      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      }

      delete params.date;

      if (params.amount)
        params.amount = params.amount.toString().replace(/\s/g, "");

      card.pageCashLendingRemuneration({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ...params,
        },
        success: (res) => {
          _this.table = res.data || {};
          _this.isLoading = false;
        },
      });
      _this.isLoading = false;
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    addRecordVisible() {
      this.addForm = {
        accountAmount: this.cardInfo.accountAmount,
        agentId: null,
        amount: "",
        remark: "",
      };
      this.loadAgents();
      this.isVisible = true;
    },

    loadAgents() {
      org.getOrgUserPage({
        param: { current: 1, size: 1000 },
        success: (res) => {
          this.agentList = (res.data?.records || []).filter(
            (a) => a.job === "AGENT",
          );
        },
      });
    },

    onAgentChange(agentId) {
      this.$set(this.addForm, "amount", "");
      if (!agentId) {
        this.selectedAgentCard = null;
        return;
      }
      if (agentId === "all") {
        this.selectedAgentCard = null;

        this.$nextTick(() => {
          this.$set(
            this.addForm,
            "amount",
            String(this.selectedAccountAmountRaw).replace(
              /\B(?=(\d{3})+(?!\d))/g,
              " ",
            ),
          );
        });
        return;
      }
      card.getCardByOrgInfoId({
        param: { agentId },
        success: (res) => {
          if (res.code == 200) this.selectedAgentCard = res.data;
          else {
            this.selectedAgentCard = null;
            this.$message.warning(this.$t(res.msg));
          }
        },
      });
    },
    onAmountInput(val) {
      const raw = String(val || "").replace(/[^0-9]/g, "");
      this.$set(this.addForm, "amount", raw ? raw.formatMoney(0, " ") : "");
    },

    onSubmit(refName) {
      let _this = this;
      const rawAmount = parseInt(
        (_this.addForm.amount || "").replace(/\s/g, ""),
        10,
      );
      const available = parseFloat(this.selectedAccountAmountRaw || 0);
      if (rawAmount > available) {
        this.$message.warning(this.$t("300001:not sufficient funds"));
        return;
      }

      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.btnStatus.isLoading = true;

        let submitData = {
          amount: String(this.addForm.amount || "").replace(/\s/g, ""),
          accountAmount: String(this.selectedAccountAmountRaw),
          agentId:
            this.addForm.agentId === "all"
              ? null
              : this.addForm.agentId || null,
          remunerationType:
            this.addForm.agentId === "all" ? 2 : this.addForm.agentId ? 1 : 0,
          remark: this.addForm.remark || null,
        };
        card.addRemunerationToCash({
          param: submitData,
          success: (res) => {
            if (res.code == 200) {
              _this.isVisible = false;
              _this.getList();
              _this.btnStatus.isLoading = false;
              _this.$message.success(_this.$t("operateSuccessfully"));
            } else {
              _this.$message.warning(_this.$t(res.msg));
              _this.btnStatus.isLoading = false;
            }
          },
        });
        _this.btnStatus.isLoading = false;
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
    this.loadAgents();
  },
};
</script>

<style lang="less" scoped></style>
